module.exports = __webpack_public_path__ + "87c8c283bf1145c17287312c30ad5351.png";